import { caseNotesSlider } from '../components/case-notes-slider.js';

caseNotesSlider();
